export default __webpack_public_path__ + "static/media/3.7ff0957e.PNG";